import styled, { css } from 'styled-components';
import { palette, theme } from 'styled-tools';

import { minWidth } from '../../utils/mediaQueries';
import { fontSize, fontWeight, lineHeight } from '../../utils/typography';
import { FontSizes, FontWeights } from '../../utils/typography/types';
import { OptionalBackgroundButton } from '../Button';
import { PaletteColor } from '../ThemeProvider';

export const Wrapper = styled(OptionalBackgroundButton)<{
	$activeBackgroundColor: PaletteColor;
	$inactiveBackgroundColor: PaletteColor;
	$disabledBackgroundColor: PaletteColor;
	$activeTextColor: PaletteColor;
	$inactiveTextColor: PaletteColor;
	$disabledTextColor: PaletteColor;
	$activeBorderColor: PaletteColor;
	$inactiveBorderColor: PaletteColor;
	$isActive: boolean;
	$borderWidth: number;
	$borderRadius?: string;
	$padding?: string;
}>`
	${p => {
		if (p.isDisabled) {
			return css`
				background: ${palette(p.$disabledBackgroundColor)};
				color: ${palette(p.$disabledTextColor)};
			`;
		}
		if (p.$isActive) {
			return css`
				background: ${palette(p.$activeBackgroundColor)};
				color: ${palette(p.$activeTextColor)};
				border-color: ${palette(p.$activeBorderColor)};
			`;
		}
		return css`
			background: ${palette(p.$inactiveBackgroundColor)};
			color: ${palette(p.$inactiveTextColor)};
			border-color: ${palette(p.$inactiveBorderColor)};
		`;
	}}
	${lineHeight(FontSizes.sm)};
	min-height: unset;
	min-width: unset;
	${minWidth('desktop')} {
		${fontSize(FontSizes.base)}
		${lineHeight(FontSizes.base)};
		min-height: ${theme('buttons.minHeight')};
		min-width: 48px;
	}
	${p => fontWeight(p.fontWeight || FontWeights.Demi)};
	padding: ${p => p.$padding || theme('buttons.chipButtons.padding')};
	border-radius: ${p => p.$borderRadius || theme('buttons.chipButtons.borderRadius')};
	&:before {
		inset: ${p => -p.$borderWidth}px;
		border-radius: ${p => p.$borderRadius || theme('buttons.chipButtons.borderRadius')};
		height: calc(100% + ${p => p.$borderWidth * 2}px);
		width: calc(100% + ${p => p.$borderWidth * 2}px);
	}
	&:after {
		border-radius: calc(
			${p => p.$borderRadius || theme('buttons.chipButtons.borderRadius')} -
				${theme('buttons.focusRingDistance')}
		);
	}
	border-width: ${p => p.$borderWidth}px;
	border-style: solid;
`;
